import { Box } from '@mui/material'
import { useTheme } from '@/contexts/ThemeContext'

interface LayoutProps {
  children: React.ReactNode
}

export default function Layout({ children }: LayoutProps) {
  const { colors } = useTheme()

  return (
    <>
      {/* Fixed background for mobile */}
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          width: '100vw',
          height: '100vh',
          backgroundImage: 'url(/images/background.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          zIndex: 0,
          '&::after': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: colors.overlay,
          },
          display: {
            xs: 'block',
            sm: 'block',
            md: 'none',
          },
        }}
      />
      {/* Desktop background */}
      <Box
        sx={{
          minHeight: '100vh',
          backgroundImage: {
            xs: 'none',
            sm: 'none',
            md: 'url(/images/background.png)',
          },
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundAttachment: 'fixed',
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          zIndex: 1,
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: colors.overlay,
            zIndex: 0,
            display: {
              xs: 'none',
              sm: 'none',
              md: 'block',
            },
          },
        }}
      >
        <Box
          sx={{
            position: 'relative',
            zIndex: 1,
            paddingInline: { xs: 1, sm: 3, md: 8 },
            paddingBlock: 3,
            flex: 1,
          }}
        >
          {children}
        </Box>
      </Box>
    </>
  )
}
